import React from "react";

const REPORT_ROWS = [
  { phoneme: "/θ/ think", from: 58, to: 74, change: "+16", color: "#1E7A4C" },
  { phoneme: "/ɪ/ ship", from: 63, to: 71, change: "+8", color: "#1E7A4C" },
  { phoneme: "/v/ very", from: 70, to: 68, change: "−2", color: "#B42318" },
];

export const MockHero = () => {
  return (
    <div className="w-full max-w-[560px]">
      <div
        className="p-6 lg:p-7"
        style={{ background: "#FFFFFF", border: "1px solid #DBD6E0", borderRadius: 12 }}
        data-testid="hero-pronunciation-report"
      >
        <div className="inline-flex px-3 py-1 text-[11px] font-medium uppercase tracking-[0.14em]" style={{ background: "rgba(114,40,200,0.08)", color: "#7228C8" }}>
          Ejemplo de informe
        </div>
        <h2 className="mt-5 text-[22px] font-bold tracking-hero" style={{ color: "#141018" }}>
          Informe de pronunciación · Sesión 1 → Sesión 2
        </h2>
        <div className="mt-6 space-y-3">
          {REPORT_ROWS.map((row) => (
            <div key={row.phoneme} className="grid grid-cols-[1fr_auto_auto_auto] gap-3 text-[15px]" style={{ color: "#141018" }}>
              <span className="font-mono-num">{row.phoneme}</span>
              <span>{row.from}</span>
              <span>→ {row.to}</span>
              <strong style={{ color: row.color }}>{row.change}</strong>
            </div>
          ))}
        </div>
        <p className="mt-6 border-t pt-5 text-[14px] leading-[1.6]" style={{ borderColor: "#DBD6E0", color: "#141018" }}>
          <strong>Qué practicar:</strong> «th» con la lengua entre los dientes.
        </p>
      </div>
    </div>
  );
};
